export class ModelSummaryStatus {
  constructor(
    public hash: string,
    public startTime: number,
    public activityName: string,
    public subactivityName: string,
    public programReference: string,
    public programTime: number,
    public running: boolean,
    public execution: boolean,
    public preparation: boolean,
    public alarm: boolean,
    public stop: boolean,
    public warning: boolean,
    public maintenance: boolean,
    public pause: boolean,
    public pauseStartTime: number,
    public totalPauseTime: number,
    public timeDiff: number
  ) { }

  get correctedStartTime() {
    return this.startTime - this.timeDiff;
  }

  get correctedPauseStartTime() {
    return this.pauseStartTime - this.timeDiff;
  }

  get subactivityDifferent() {
    return (this.subactivityName && this.activityName !== this.subactivityName) ? ` (${ this.subactivityName })` : '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-summary-status.ts